import React, { useContext } from 'react'
import classnames from 'classnames'
import Conetext from '../../../context'
import styles from './index.module.less'
import appInstall from '@/utils/appUtils/appInstall'
import imgResize from '@/utils/img-resize'
import Jockeys from '@/utils/jockey'
import { isDuApp } from '@/utils/appUtils/getDevice'
import { formatMoney } from '@/utils'
import { handleBreakCode } from '../..'
interface ItemProps {
  item: {
    price: number
    spuId: number
    spuTips: string
    spuLogoUrl: string
    spuName: string
    topDes: string
    topType: number
    breakCode: boolean
    breakCodeTag: number
  }
  index: number
}

const goDetail = (item) => {
  if (isDuApp()) {
    Jockeys.openNativePage('/sell/productDetail', {
      spuId: item.spuId,
    })
    return
  }
  appInstall('/sell/productDetail', {
    spuId: item.spuId,
  })
}

function Item({ item, index }: ItemProps) {
  const { langConfig, currencyCode, editConfig, trackHelper, handleTrack } = useContext(Conetext)

  const handleClick = (e) => {
    e.stopPropagation()
    handleBreakCode(langConfig, item.breakCodeTag, item.spuId, trackHelper)
    trackHelper('poizon_common_exposure', {
      current_page: 515,
      block_type: 3280,
      spu_id: item.spuId,
    })
  }

  return (
    <div
      data-spu-id={item.spuId}
      data-index={index}
      data-block-type={1503}
      className={styles['item']}
      onClick={() => {
        goDetail(item)
        handleTrack(index, item.spuId, 1503)
      }}
    >
      <img className={styles['cover']} data-layzload-src={imgResize(item.spuLogoUrl, 180)} alt="" />
      {item?.breakCode && (
        <div className={styles['break-code']} onClick={handleClick}>
          {(langConfig as any).breakCode}
        </div>
      )}
      <div className={styles['desc']}>{item.spuName}</div>
      <div className={classnames({ [styles['info']]: true })}>
        <div className={styles['price']}>
          {currencyCode} {formatMoney(item.price, !!editConfig.local)}
        </div>
        <div className={styles['text']}>{item.spuTips}</div>
      </div>
      <div
        className={classnames({
          [styles['hot']]: true,
          [styles['sales']]: item.topType === 2,
          [styles['new']]: item.topType === 3,
          [styles['surge']]: item.topType === 1,
        })}
      >
        <div className={styles['ico']}>{langConfig.youLike.booklistIco}</div>
        {item.topDes}
      </div>
    </div>
  )
}

export default Item
